// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__4QTk7","spin":"styles_spin__2HRiY"};